module.exports = __webpack_public_path__ + "media/images/application/icons/options-red-081d6413aa9270f9143d42a9dac834c8.svg";